const en = require("./lang/en.json");
const nl = require("./lang/nl.json");
const de = require("./lang/de.json");
import Vue from "vue";
import $ from "jquery";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const htmlLang = $('html').attr('lang');
const locale = htmlLang && ['en', 'nl', 'de'].includes(htmlLang) ? htmlLang : 'en';

const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: {
        en: en,
        nl: nl,
        de: de
    }
});

export default i18n;
